import { createApp as createVueApp } from 'vue'
import App from './App.vue'
import { loadFonts } from './plugins/webfontloader'
import vuetify from './plugins/vuetify'
import {createAppRouter, routes} from './router'
import i18n from './i18n'
import 'leaflet/dist/leaflet.css'
import {ViteSSG} from "vite-ssg";
import '@/assets/styles/main.css'

loadFonts()

export const createApp = ViteSSG(
    App,
    {
      routes,
      scrollBehavior: (_to: any, _from: any, savedPosition: any) => {
        if (savedPosition) {
          return savedPosition;
        } else {
          return { top: 0 };
        }
      }
    },
    ({ app, router, isClient }) => {
      app.use(vuetify);
      app.use(i18n);
      
      // 确保在客户端和服务端都正确初始化 i18n
      if (isClient) {
        // 客户端特定的初始化
        router.afterEach(() => {
          // 可以在这里添加路由后的语言检测逻辑
        });
      }
    }
);
